// officers/order-list
import React from 'react';
import View from 'src/pages/coming-soon';

const Page = () => {
  return <View message="Danh các lịch đã được sắp cho giáo viên" />;
};

export default Page;
